@if (visible) {
  <div [ngClass]="getClasses()">
    <span class="osc-spinner__spin"></span>
    @if (needProgressMessage) {
      <div class="progress-message">
        <h3 class="progress-message-header">{{progressMessageHeader}}</h3>
        <p>{{progressMessage}}</p>
      </div>
    }
  </div>
}